/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import React from 'react';

import styles from './style/index.module.less';

interface ILoadingProps {
  bgColor?: string;
  pointColor?: string;
  style?: React.CSSProperties;
}

const Loading = (props: ILoadingProps) => {
  const { bgColor, pointColor, style } = props;
  return (
    <div className={styles.root} style={{ ...style, background: bgColor }}>
      <div className={styles.loading} style={{ color: pointColor }}>
        <div className={styles.content}></div>
        <div className={styles.content}></div>
        <div className={styles.content}></div>
      </div>
    </div>
  );
};

export default (Loading);
